import CaseOptionsCard from "components/CaseOptions";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { ECaseViews } from "components/CaseView/dto/ECaseViews";
import CaseStatusIcons from "components/CaseStatusIcons";
import { cleanSearchHighlight } from "utils/cleanSearchHighlight";

const CaseRightSideHeader: FC<Props> = ({
  hideOptions,
  optionsRef,
  Case,
  statuses,
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.information}>
        <div className={styles.top}>{cleanSearchHighlight(Case.Signature)}</div>
        <div className={styles.bottom}>
          <CaseStatusIcons Case={Case} />
        </div>
      </div>
      {!hideOptions && (
        <div ref={optionsRef}>
          <CaseOptionsCard
            showDropdown={false}
            showOptions={true}
            showSomething={true}
            pack={Case}
            refetch={() => {}}
            refWrapper={optionsRef}
            onClickEdit={() => {}}
            onClickAttachIcon={() => {}}
            toggle={() => {}}
            threadsRef={null}
            setShowThreads={() => {}}
            showThreads={false}
            showCreateFolder={false}
            setShowCreateFolder={() => {}}
            view={ECaseViews.ACTIONS}
            rightSide={true}
            statuses={statuses}
            showEditTags={false}
            setShowEditTags={function (): void {
              throw new Error("Function not implemented.");
            }}
          />
        </div>
      )}
    </div>
  );
};

export default CaseRightSideHeader;
